import { render, staticRenderFns } from "./MyTable.vue?vue&type=template&id=6927a4ba"
import script from "./MyTable.vue?vue&type=script&lang=js"
export * from "./MyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports